import { call, put, takeLatest } from 'redux-saga/effects';

import { promoBarUpdateError, promoBarUpdateRequest, promoBarUpdateStore } from './promoBarActions.js';
import { updatePromoBarApiCall } from './promoBarAPI.js';

function* updatePromoBarSaga({ payload }) {
  try {
    const { data } = yield call(updatePromoBarApiCall, payload);
    yield put(promoBarUpdateStore(data));
  } catch (error) {
    yield put(promoBarUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* promoBarWatcher() {
  yield takeLatest(promoBarUpdateRequest.type, updatePromoBarSaga);
}
